<template>
  <div v-typo class="wrap flex flex-col min-h-screen">
    <MainHeader />
    <main class="flex-1 container pt-3 pb-16 md:pt-5 md:pb-20 lg:pt-6 lg:pb-24">
      <router-view />
    </main>
    <MainFooter />
    <ScrollToTop />
    <CookieBanner />
    <ToastNotification
      v-if="toast.message"
      :key="toast.id"
      :message="toast.message"
      :showUndo="toast.showUndo"
      :duration="toast.duration"
      @undo="toast.runUndo()"
      @close="toast.dismiss()"
      @hidden="toast.dismiss()"
    />
  </div>
</template>

<script>
import { useCart } from '@/store/useCart'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import MainHeader from '@/components/header/MainHeader.vue'
import MainFooter from '@/components/footer/MainFooter.vue'
import ScrollToTop from '@/components/ScrollToTop.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import ToastNotification from '@/components/Toast.vue'

export default {
    setup() {
        const cart = useCart();
        const authGo = useAuth();
        const toast = useToast();

        return { cart, authGo, toast }
    },
  components: {
    MainHeader, MainFooter, ScrollToTop, CookieBanner, ToastNotification
  },
    created() {
      
      if (!localStorage.token) {
        this.authGo.logInGuest('UmVnaW9uOjE=');
      
      }
      
      
      
      this.cart.refreshCart();
    },
}
</script>